/* eslint-disable function-paren-newline */
import { searchValue } from 'src/shared/AppUtils';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { getRecordGroups } from '../SchoolGradeOlogyApis';
import SelectMenu from './SelectMenu';

const DESKTOP_MIN_WIDTH = 640;

function RecordGroupsMenu({ onSelectGroup, width }) {
  const [groups, setGroups] = useState([]);
  const [selectedGroupKeys, setselectedGroupKeys] = useState([]);
  const [selectedGroupKey, setselectedGroupKey] = useState();

  const isDesktop = useMemo(() => width >= DESKTOP_MIN_WIDTH, [width]);

  const items = useMemo(() => {
    const result = groups.map(({ Name, ID }) => ({
      label: Name,
      key: ID,
    }));

    return result;
  }, [groups]);

  const handleSelectItem = useCallback(
    (item, groupItems) => {
      const key = item.key ?? item;
      if (isDesktop) {
        setselectedGroupKeys([key]);
      } else {
        setselectedGroupKey(key);
      }

      if (onSelectGroup) {
        const selectedGroupItem = (groupItems ?? groups).find(
          ({ ID }) => ID === +key
        );
        onSelectGroup(selectedGroupItem);
      }
    },
    [isDesktop, groups]
  );

  useEffect(() => {
    if (!width) {
      return;
    }
    getRecordGroups().then((value) => {
      setGroups(value);
      // eslint-disable-next-line operator-linebreak
      const selectedGroupId = value[0]?.ID;
      if (!selectedGroupId) {
        return;
      }
      handleSelectItem(selectedGroupId.toString(), value);
    });
  }, [isDesktop, width]);

  const handleSearch = useCallback((searchText, option) =>
    searchValue(searchText.toLowerCase(), option.children)
  );

  return (
    <SelectMenu
      isDesktop={isDesktop}
      selectedKeys={selectedGroupKeys}
      selectedKey={selectedGroupKey}
      menuItems={items}
      handleSelectItem={handleSelectItem}
      handleSearch={handleSearch}
    />
  );
}

export default RecordGroupsMenu;
